<div fxLayout="column" style="padding:15px;">

  <mat-card>
    <mat-card-title>
      <app-page-header [title]="pageTitle" action=''></app-page-header>
    </mat-card-title>

    <mat-card-content fxLayout="column">
      <div fxLayout="row" fxFlex fxLayoutAlign="center center center" style="margin-top: 20px;">
        <div fxLayout="row" fxFlex style="width:100%; padding:15px;">

          <mat-tab-group style="width: 100%;">
            <mat-tab>
              <ng-template mat-tab-label>
                <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                  Δηλώσεις συναίνεσης
                </div>
              </ng-template>

              <div fxLayout="column" fxFlex>

                <div fxLayout="row" fxLayoutAlign="start center center" fxLayoutGap="15px" style="margin-top: 20px; width: 100%;">
                  <span>Αναζήτηση</span>
                  <mat-form-field>
                    <label>
                      <input matInput (keydown)="search($event.target.value)" placeholder="Αναζήτηση">
                    </label>
                  </mat-form-field>
                </div>
                <div fxLayout="row" style="overflow-y: auto; margin-top:20px; width: 100%;" [style.height.px]="tableHeight">

                  <mat-table style="width: 100%;"  [dataSource]="logs" matSort>
                    <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center"
                              class="mat-elevation-z0">
                      <mat-spinner
                              color="primary"
                              mode="indeterminate">
                      </mat-spinner>
                    </mat-card>

                    <ng-container matColumnDef="parentDisplayName">
                      <mat-header-cell  *matHeaderCellDef fxFlex="10" fxLayoutAlign="center center center" mat-sort-header> Γονέας </mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="10" fxLayoutAlign="center center center"> {{log.parentDisplayName}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="childDisplayName">
                      <mat-header-cell  *matHeaderCellDef  fxFlex="10" fxLayoutAlign="center center center" mat-sort-header> Παιδί </mat-header-cell>
                      <mat-cell  *matCellDef="let log"  fxFlex="10" fxLayoutAlign="center center center"> {{log.childDisplayName}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="formTitle" >
                      <mat-header-cell  *matHeaderCellDef fxFlex="15" fxLayoutAlign="start center center" mat-sort-header> Δήλωση</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="15" fxLayoutAlign="start center center"> {{log.formTitle}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="consentDescription"  >
                      <mat-header-cell  *matHeaderCellDef fxFlex="20" fxLayoutAlign="start center center"> Ερώτηση</mat-header-cell>
                      <mat-cell  class="question" *matCellDef="let log" fxFlex="20" fxLayoutAlign="start center center">
                        <label [matTooltip]="log.consentDescription"> {{ log.consentDescription | slice:0:80 }}{{log.consentDescription.length > 80 ? '...' : ''}} </label>

                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="consentValue">
                      <mat-header-cell  *matHeaderCellDef fxFlex="10" fxLayoutAlign="center center center">Κατάσταση</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="10" fxLayoutAlign="center center center">
                        <div class="statusButton" [ngStyle]="{'background-color': commonService.getButtonColor(+log.consentValue)}"
                             fxLayoutAlign="center center center">{{+log.consentValue === 1 ? 'Αποδοχή' : +log.consentValue === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="first_sent"  >
                      <mat-header-cell  *matHeaderCellDef fxFlex="7.5" fxLayoutAlign="center center center" mat-sort-header> Ημ. Δημιουργίας</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="7.5" fxLayoutAlign="center center center"> {{log.first_sent}} </mat-cell>
                    </ng-container>



                    <ng-container matColumnDef="consentDate" >
                      <mat-header-cell  *matHeaderCellDef fxFlex="7.5" fxLayoutAlign="center center center" mat-sort-header> Ημ. Ενημέρωσης</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="7.5" fxLayoutAlign="center center center"> {{log.consentDate}} </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="unique_token" >
                      <mat-header-cell  *matHeaderCellDef fxFlex="15" fxLayoutAlign="center center center"> Token</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="15" fxLayoutAlign="center center center"> {{log.unique_token}} </mat-cell>
                    </ng-container>


                    <mat-header-row  *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
<!--                    <mat-row  *matRowDef="let record; columns: columnsToDisplay" (click)="navigateToDetails(record)"></mat-row>-->
                    <mat-row  *matRowDef="let record; columns: columnsToDisplay"></mat-row>
                  </mat-table>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center center">
                  <mat-paginator [length]="logs.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]">
                  </mat-paginator>
                </div>
              </div>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                  Δηλώσεις εγγραφής
                </div>
              </ng-template>

              <div fxLayout="column" fxFlex>

                <div fxLayout="row" fxLayoutAlign="start center center" fxLayoutGap="15px" style="margin-top: 20px; width: 100%;">
                  <span>Αναζήτηση</span>
                  <mat-form-field>
                    <label>
                      <input matInput (keydown)="searchAffirmations($event.target.value)" placeholder="Αναζήτηση">
                    </label>
                  </mat-form-field>
                </div>
                <div fxLayout="row" style="overflow-y: auto; margin-top:20px; width: 100%;" [style.height.px]="tableHeight">

                  <mat-table style="width: 100%;"  [dataSource]="affirmationLogs" matSort>
                    <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center"
                              class="mat-elevation-z0">
                      <mat-spinner
                              color="primary"
                              mode="indeterminate">
                      </mat-spinner>
                    </mat-card>

                    <ng-container matColumnDef="parentDisplayName">
                      <mat-header-cell  *matHeaderCellDef fxFlex="10" fxLayoutAlign="center center center" mat-sort-header> Γονέας </mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="10" fxLayoutAlign="center center center"> {{log.parentDisplayName}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="childDisplayName">
                      <mat-header-cell  *matHeaderCellDef  fxFlex="10" fxLayoutAlign="center center center" mat-sort-header> Παιδί </mat-header-cell>
                      <mat-cell  *matCellDef="let log"  fxFlex="10" fxLayoutAlign="center center center"> {{log.childDisplayName}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="formTitle" >
                      <mat-header-cell  *matHeaderCellDef fxFlex="15" fxLayoutAlign="start center center" mat-sort-header> Δήλωση</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="15" fxLayoutAlign="start center center"> {{log.formTitle}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="activity_description"  >
                      <mat-header-cell  *matHeaderCellDef fxFlex="20" fxLayoutAlign="start center center">Δραστηριότητα</mat-header-cell>
                      <mat-cell  class="question" *matCellDef="let log" fxFlex="20" fxLayoutAlign="start center center">
                        <label [matTooltip]="log.activity_description"> {{ log.activity_description | slice:0:80 }}{{log.activity_description.length > 80 ? '...' : ''}} </label>

                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status_id">
                      <mat-header-cell  *matHeaderCellDef fxFlex="10" fxLayoutAlign="center center center">Κατάσταση</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="10" fxLayoutAlign="center center center">
                        <div class="statusButton" [ngStyle]="{'background-color': commonService.getButtonColor(+log.status_id)}"
                             fxLayoutAlign="center center center">{{+log.status_id === 1 ? 'Αποδοχή' : +log.status_id === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="action_date"  >
                      <mat-header-cell  *matHeaderCellDef fxFlex="7.5" fxLayoutAlign="center center center" mat-sort-header> Ημ. Δημιουργίας</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="7.5" fxLayoutAlign="center center center"> {{log.action_date}} </mat-cell>
                    </ng-container>



                    <ng-container matColumnDef="unique_token" >
                      <mat-header-cell  *matHeaderCellDef fxFlex="15" fxLayoutAlign="center center center"> Token</mat-header-cell>
                      <mat-cell  *matCellDef="let log" fxFlex="15" fxLayoutAlign="center center center"> {{log.unique_token}} </mat-cell>
                    </ng-container>


                    <mat-header-row  *matHeaderRowDef="columnsToDisplayAffirmations; sticky: true"></mat-header-row>
<!--                    <mat-row  *matRowDef="let record; columns: columnsToDisplayAffirmations" (click)="navigateToAffirmationDetails(record)"></mat-row>-->
                    <mat-row  *matRowDef="let record; columns: columnsToDisplayAffirmations"></mat-row>
                  </mat-table>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center center">
                  <mat-paginator #affirmationPaginator [length]="affirmationLogs.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]">
                  </mat-paginator>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <!--        -->
      </div>
    </mat-card-content>
  </mat-card>

</div>
